import * as R from "ramda"

export const FORM_FIELDS = Object.freeze({
  ORIGIN: "origin",
  DESTINATION: "destination",
  OUTBOUND_DATE: "outboundDate",
  INBOUND_DATE: "inboundDate",
  DATE_RANGE: "dateRange",
  TIME_OF_STAY: "timeOfStay",
  SORT: "sort",
  TRANSPORT_TYPES: "transportTypes",
  CABIN_TYPE_MIXED_ALLOWED: "cabinTypeMixedAllowed",
  CABIN_TYPE: "cabinType",
  MAX_TRAVEL_DURATION: "maxTravelDuration",
})

export type FormFieldType = typeof FORM_FIELDS[keyof typeof FORM_FIELDS]

export const NEXT_FIELD = {
  origin: "destination",
  destination: "outboundDate",
  outboundDate: "inboundDate",
  inboundDate: null,
} as const

export const DIRECTIONS = {
  OUTBOUND: "outbound",
  INBOUND: "inbound",
} as const

export const CHANGE_TYPES: {
  MODE: "mode"
  MODE_CLOSE: "modeClose"
  RADIUS: "radius"
  UPDATE: "update"
  SELECT: "select"
  DELETE: "delete"
} = {
  MODE: "mode",
  MODE_CLOSE: "modeClose", // change mode, then close
  RADIUS: "radius",
  UPDATE: "update",
  SELECT: "select",
  DELETE: "delete", // delete item from multiplace
}

const reduxFormRedundantProps = [
  "initialValue",
  "autofill",
  "onUpdate",
  "valid",
  "invalid",
  "dirty",
  "pristine",
  "error",
  "active",
  "touched",
  "visited",
  "autofilled",
  "format",
  "corrector",
]

// NOTE not always good to do since sometimes input fields need to be prefilled..
// NOTE but that throws warning by React
export const omitRedundantFields = R.omit(reduxFormRedundantProps)

export const InputProps = ["type", "files", "name", "onBlur", "onChange", "onFocus"] as const
